import { CSS } from '@grupoboticario/flora-react'

export const wrapperCss: CSS = {
  backgroundColor: '$actionableDefault',
  minHeight: '$14'
}

export const logoSideCss: CSS = {
  flex: '1',
  marginLeft: '$4'
}

export const hamburgerIconCss: CSS = {
  cursor: 'pointer',
  display: 'initial'
}

export const centerSlotCss: CSS = {
  flex: '3'
}

export const rightSlotCss: CSS = {
  flex: '1',
  marginRight: '$4'
}
